import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {ChatModelType} from '../../../../models/chatModel';
import {Auth} from '../../../../models/authModel';
import {withRouter, RouteComponentProps} from 'react-router';

export interface ChatContactActionProps {
  userId: number;
  label?: string;
}

interface WithInjectedProps extends ChatContactActionProps, RouteComponentProps {
  chat: ChatModelType;
  auth: Auth;
}

@inject('chat', 'auth')
@observer
class ChatContactAction extends React.Component<ChatContactActionProps & RouteComponentProps, {}> {
  public render() {
    const {label} = this.props;
    return <button onClick={this._handleClick}>{label ? label : 'Contact'}</button>;
  }

  private _handleClick = () => {
    const {auth, chat, userId} = this._withInjectedProps;
    chat.createChannel([auth.profile!.id, userId], true, this._redirectToChannel);
  };

  // tslint:disable-next-line:no-any
  private _redirectToChannel = (data: any) => {
    this._withInjectedProps.history.push(`/messages/${data.channel.id}`);
  };

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}

export default withRouter(ChatContactAction);



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatGenericTemplateMessage/predefinedActions/ChatContactAction.tsx